import PropTypes from 'prop-types';
import React from 'react';

import styles from './OptionItem.module.scss';

const OptionItem = ({ id, icon, label }) => (
  <div id={id} className={[styles.option, 'flex-row', 'vertically-centered', 'gap-6'].join(' ')}>
    <img className={styles.icon} src={icon} alt="option-icon" />
    <span className="font-s-14">{label}</span>
  </div>
);

OptionItem.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
};

export default OptionItem;
